(function () {
  'use strict';

  function withVat(pence) {
    return Math.round(pence * 1.2);
  }
  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  /* ---------- Gallery ---------- */
  function initBuyBox(root) {
    if (root.dataset.mrChairReady) return;
    root.dataset.mrChairReady = 'true';
    var money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: root.dataset.currency || 'GBP'
    });
    function format(pence) { return money.format(pence / 100); }
    var variants = JSON.parse(root.querySelector('[data-mr-product-variants]').textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[data-mr-variant-id]');
    var addButton = form.querySelector('[data-mr-add]');
    var errorBox = form.querySelector('[data-mr-add-error]');
    var isChair = root.getAttribute('data-is-chair') === 'true';
    var title = root.getAttribute('data-title') || '';
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var mobileBar = root.querySelector('[data-mr-mobile-buy]');
    var mobilePrice = root.querySelector('[data-mr-mobile-price]');
    var busy = false;
    var availability = root.querySelector("[data-mr-availability]");

    function updateAvailability(variant) {
      if (!availability) return;
      var link = document.createElement('a');
      var prefix = '';
      var suffix = '';
      if (!variant.available) {
        prefix = 'Currently unavailable. ';
        link.textContent = 'Ask about a demonstration';
        link.href = root.dataset.demoUrl;
      } else if (root.dataset.confirmedStock === 'true') {
        prefix = root.dataset.stockMessage + ' ';
        if (root.dataset.assessmentRequired === 'true') {
          link.textContent = 'Contact us';
          link.href = root.dataset.contactUrl;
          suffix = ' to arrange a stair assessment.';
        } else {
          link.textContent = 'Delivery information';
          link.href = root.dataset.deliveryUrl;
        }
      } else if (root.dataset.assessmentRequired === 'true') {
        link.textContent = 'Contact us';
        link.href = root.dataset.contactUrl;
        suffix = ' to arrange a stair assessment and confirm delivery.';
      } else if (variant.backorder) {
        prefix = 'Available to backorder. ';
        link.textContent = 'Contact us for the expected delivery date.';
        link.href = root.dataset.contactUrl;
      } else {
        prefix = 'In stock. ';
        link.textContent = 'Delivery information';
        link.href = root.dataset.deliveryUrl;
      }
      availability.replaceChildren(document.createTextNode(prefix), link, document.createTextNode(suffix));
    }

    var addonsRoot = root.querySelector('[data-mr-addons]');
    var addons = addonsRoot ? all(addonsRoot, '[data-mr-addon]').map(function (element) {
      return {
        element: element,
        check: element.querySelector('[data-mr-addon-check]'),
        select: element.querySelector('[data-mr-addon-select]'),
        options: element.querySelector('[data-mr-addon-options]'),
        added: element.querySelector('[data-mr-addon-added]'),
        priceEl: element.querySelector('[data-mr-addon-price]'),
        extra: element.hasAttribute('data-mr-addon-extra')
      };
    }) : [];
    var showAll = false;

    function addonPrice(addon) {
      if (addon.select) {
        var option = addon.select.options[addon.select.selectedIndex];
        return Number(option.getAttribute('data-price'));
      }
      return Number(addon.element.getAttribute('data-price'));
    }
    function addonId(addon) {
      return addon.select ? addon.select.value : addon.check.value;
    }
    function selectedAddons() {
      return addons.filter(function (addon) { return addon.check.checked; });
    }

    function render() {
      var chosen = selectedAddons();
      var totalWrap = root.querySelector('[data-mr-total-wrap]');
      if (totalWrap) totalWrap.hidden = chosen.length === 0;
      var total = withVat(current.price) + chosen.reduce(function (sum, addon) { return sum + withVat(addonPrice(addon)); }, 0);
      all(root, '[data-mr-total]').forEach(function (el) { el.textContent = format(total); });
      var label = root.querySelector('[data-mr-total-label]');
      if (label) {
        label.textContent = (chosen.length
          ? 'Chair + ' + chosen.length + ' accessor' + (chosen.length === 1 ? 'y' : 'ies')
          : isChair ? 'Chair only' : title) + ' · including VAT';
      }

      var priceEx = root.querySelector('[data-mr-price-ex]');
      var priceInc = root.querySelector('[data-mr-price-inc]');
      var wasWrap = root.querySelector('[data-mr-price-was-wrap]');
      if (priceEx) priceEx.textContent = format(current.price);
      if (mobilePrice) mobilePrice.textContent = format(current.price);
      if (priceInc) priceInc.textContent = format(withVat(current.price));
      if (wasWrap) {
        var hasWas = current.compare_at_price > current.price;
        wasWrap.hidden = !hasWas;
        if (hasWas) wasWrap.querySelector('[data-mr-price-was]').textContent = format(current.compare_at_price);
      }

      var text = current.available ? addButton.getAttribute('data-label') : addButton.getAttribute('data-sold-out');
      if (!busy) {
        addButton.textContent = text;
        addButton.disabled = !current.available;

      }

      addons.forEach(function (addon) {
        var on = addon.check.checked;
        addon.element.classList.toggle('is-selected', on);
        if (addon.options) addon.options.hidden = !on;
        if (addon.added) addon.added.hidden = !on;
        if (addon.priceEl) addon.priceEl.textContent = format(withVat(addonPrice(addon)));
        if (addon.extra) addon.element.hidden = !(showAll || on);
      });
      if (addonsRoot) {
        var status = addonsRoot.querySelector('[data-mr-addons-status]');
        var note = addonsRoot.querySelector('[data-mr-addons-note]');
        var panel = addonsRoot.querySelector('[data-mr-addons-panel]');
        if (status) status.textContent = 'Optional' + (chosen.length ? ' · ' + chosen.length + ' selected' : '');
        if (note) {
          note.hidden = !(panel.hidden && chosen.length);
          note.textContent = chosen.length + ' selected · included in your total below.';
        }
      }
    }

    // Keep buying options within reach without skipping choices or the VAT declaration.
    if (mobileBar && 'IntersectionObserver' in window) {
      var purchaseObserver = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        mobileBar.hidden = !show;
        document.body.classList.toggle('mr-mobile-buy-visible', show);
      }, {threshold: 0});
      purchaseObserver.observe(addButton);
      root.querySelector('[data-mr-mobile-link]').addEventListener('click', function (event) {
        event.preventDefault();
        var options = root;
        options.focus({preventScroll: true});
        options.scrollIntoView({block: 'start', behavior: 'auto'});
      });
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(root)) { purchaseObserver.disconnect(); document.body.classList.remove('mr-mobile-buy-visible'); }
      });
    }

    /* Options */
    all(root, '[data-mr-option]').forEach(function (fieldset) {
      var position = Number(fieldset.getAttribute('data-mr-option'));
      all(fieldset, '[data-mr-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          var wanted = current.options.slice();
          wanted[position] = button.getAttribute('data-mr-option-value');
          var match = variants.filter(function (v) {
            return v.options.every(function (value, i) { return value === wanted[i]; });
          })[0];
          if (!match) return;
          current = match;
          updateAvailability(match);
          idInput.value = String(match.id);
          all(fieldset, '[data-mr-option-value]').forEach(function (other) {
            var on = other === button;
            other.setAttribute('aria-pressed', String(on));
          });
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', String(match.id));
            window.history.replaceState({}, '', url.toString());
          } catch (error) { /* older browsers keep the old address */ }
          render();
        });
      });
    });

    /* Accessory add-ons */
    if (addonsRoot) {
      var trigger = addonsRoot.querySelector('[data-mr-addons-trigger]');
      var panel = addonsRoot.querySelector('[data-mr-addons-panel]');
      var more = addonsRoot.querySelector('[data-mr-addons-more]');
      trigger.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        trigger.setAttribute('aria-expanded', String(!panel.hidden));
        render();
      });
      if (more) {
        more.addEventListener('click', function () {
          showAll = !showAll;
          more.textContent = showAll ? more.getAttribute('data-fewer') : more.getAttribute('data-more');
          render();
        });
      }
      addons.forEach(function (addon) {
        addon.check.addEventListener('change', render);
        if (addon.select) addon.select.addEventListener('change', render);
      });
    }

    /* Add to basket: chair plus any selected accessories, then on to the basket */
    function showError(text) {
      if (!errorBox) return;
      errorBox.textContent = text || '';
      errorBox.hidden = !text;
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy || !current.available) return;
      busy = true;
      showError('');
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addButton.textContent = 'Adding…';
      var items = [{ id: current.id, quantity: 1 }].concat(selectedAddons().map(function (addon) {
        return { id: Number(addonId(addon)), quantity: 1 };
      }));
      fetch(root.getAttribute('data-cart-add-url') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Sorry, that could not be added to your basket.');
            return data;
          });
        })
        .then(function () {
          window.location.assign(root.getAttribute('data-cart-url'));
        })
        .catch(function (error) {
          busy = false;
          addButton.setAttribute('aria-busy', 'false');
          showError(error.message);
          render();
        });
    });
    render();
  }

  function init() {
    all(document, '[data-mr-product]').forEach(initBuyBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
